<template>
  <div class="reuseHeader">
    <div class="arrow" @click="back">
      <van-icon name="arrow-left" size="24"/>
    </div>
    <div class="center">{{title}}</div>
    <div class="detailsRight" v-if="isDetails">
      <img @click="show = true" src="@/assets/customer-service.png" alt="">
    </div>
    <div class="right" v-else></div>
    <van-popup
      v-model="show"
      style="overflow-y: visible"
      @close="closePop">
      <template>
        <div class="feedBack">
          <div class="feedHeader">
            <h5>Feedback</h5>
          </div>
          <div class="feedMain">
            <p class="subTip">Describe the problem encountered：</p>
              <van-field
                v-model="feedBackText"
                rows="3"
                autosize
                type="textarea"
                maxlength="160"
                placeholder="Please enter"
                show-word-limit
              >
              <template  #left-icon>
                <img src="@/assets/orders.png" alt="" class="placeholder-icon" >
              </template>
            </van-field>
            <van-button color="#DBEC55" round :loading="btnLoading" loading-type="spinner" @click="submit" :disabled="!feedBackText" class="reuseBtn">Submit</van-button>
            <p class="phoneTip">
              You can also call customer service directly：
            </p>
            <div class="copyPhone">
              <div class="left">{{customerPhone}}</div>
              <div class="btn" @click="copyPhone">Copy</div>
            </div>
          </div>
          <div class="close" @click="closePop">
            <img src="@/assets/closePopIcon.png" alt="">
          </div>
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { feedBack, getCustomerInfo } from '@/http/api'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isDetails: {
      type: Boolean,
      default: true
    },
    toBack: {
      type: Function
    },
    backDot: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      feedBackText: '',
      btnLoading: false,
      customerPhone: ''
    }
  },
  created () {
    if (this.isDetails) {
      this.getPhone()
    }
  },
  methods: {
    back () {
      if (this.backDot) {
        this.$emit('backDot')
      }
      if (this.toBack) {
        this.$emit('toBack')
        return
      }
      if (this.$route.path !== sessionStorage.getItem('initialPath')) {
        this.$router.go(-1)
      } else {
        this.$javaNative(0)
      }
    },
    closePop () {
      this.show = false
      this.feedBackText = ''
    },
    submit () {
      this.btnLoading = true
      feedBack({
        content: this.feedBackText,
        title: localStorage.getItem('pageTitle')
      }).then(res => {
        if (res.code === '200') {
          this.$toast('Enviado con éxito')
          this.feedBackText = ''
          this.show = false
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    copyPhone () {
      this.$copyText(this.customerPhone).then(() => {
        Toast('Copy successfully')
      })
    },
    getPhone () {
      getCustomerInfo().then(res => {
        if (res.code === '200') {
          this.customerPhone = res.data.phone
        }
      })
    }

  }
}
</script>

<style scoped lang="less">
.reuseHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  .arrow{
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .center {
    font-size: 18px;
    font-weight: bold;
  }
  .detailsRight {
    display: flex;
    align-items: center;
    img {
      height: 30px;
    }
    span {
      color: #AE24F3;
      font-size: 14px;
    }
  }
  .right {
    width: 30px;
  }
}
.feedBack {
  width: 340px;
  padding: 24px 0;
  .feedHeader {
    display: flex;
    justify-content: center;
    h5 {
      font-weight: 600;
      font-size: 18px;
    }
  }
  .feedMain {
    background-color: #fff;
    border-radius: 16px;
    padding: 16px 17px;
    .subTip {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      text-align: left;
    }
    .van-field {
      background: #F6F7FB;
      // height: 150px;
      border-radius: 8px;
      margin: 12px 0;
    }

    .reuseBtn {
      color: #000000 !important;
      font-size: 16px;
      font-weight: bold;
    }
    .phoneTip {
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      text-align: left;
      margin: 24px 0 16px;
    }
    .copyPhone {
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 52px;
      .left{
        flex: 1;
        height: 52px;
        background: #F2F2F2;
        border-radius: 6px;
        font-weight: 500;
      }
      .btn {
        width: 95px;
        height: 52px;
        font-family: Inter, Inter;
        background: #DBEC55;
        border-radius: 6px;
        color: #000000;
        font-weight: 600;
        margin-left: 8px;
      }
    }
  }
  .close {
    position: absolute;
    top: -40px;
    right: 10px;
    transform: translateX(50%);
    width: 32px;
    height: 32px;
    pointer-events: auto;
    display: flex;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.van-popup {
  border-radius: 10px;
}
/deep/ .van-field__control {
  min-height: 120px !important;
}
/deep/ .van-cell{
  padding: 9px 7px !important;
}
.placeholder-icon{
  margin-top: 3px;
  height: 18px;
  width: 18px;
}
</style>
